import { get } from "./httpClient";

/**
 * Get site configuration data (event types, locations, etc.)
 * Cached for 30 minutes
 */
export async function getSiteData(site: string) {
  return get(`/sites/${site}`, { cacheResponse: 30 });
}